module.exports = __webpack_public_path__ + "static/media/sellCar.222a4a50.png";